module.exports = __webpack_public_path__ + "static/media/LOGO_DOEN_ZWART.a49dea53.png";